export default __webpack_public_path__ + "static/media/armor-sets.b6d119a2.png";